export const StatusValues = {
  NOT_STARTED: 1,
  ON_HOLD: 2,
  IN_PROGRESS: 3,
  COMPLETED: 4,
};

export const TMSStepTypes = {
  INTERCHANGE: 1, // Entrega ao transporte (Troca de WMS para TMS)
  SHIPMENT: 2, // Embarque
  TRANSFER_DELIVERY: 3, // Transporte *
  CARRIER: 4, // Rota de entrega
  DELIVERY: 5, // Entrega
  CANCELED: 6,
  NOT_INCLUDED: 7, // Transporte não contratado
  ARRIVAL_BRANCH: 31, // Chegada filial
};

export const WMSStepTypes = {
  SEPARATION: 1, // Separação
  INTERCHANGE: 2, // Entrega ao transporte
  CANCELED: 3,
  NOT_INCLUDED: 4, // Armazém não contratado
};

export const WMSStepTypesTranskey = {
  [WMSStepTypes.SEPARATION]: 'Separação', // Separação
  [WMSStepTypes.INTERCHANGE]: 'Entregue ao transporte ',
  [WMSStepTypes.CANCELED]: 'Pedido cancelado',
  [WMSStepTypes.NOT_INCLUDED]: 'Armazém não contratado', // Armazém não contratado
};
export const TMSStepTypesTranskey = {
  [TMSStepTypes.INTERCHANGE]: 'Entrega ao transporte', // Entrega ao transporte (Troca de WMS para TMS)
  [TMSStepTypes.SHIPMENT]: 'Embarque', // Embarque
  [TMSStepTypes.CARRIER]: 'Rota de entrega', // Transporte
  [TMSStepTypes.TRANSFER_DELIVERY]: 'Transferência',
  [TMSStepTypes.DELIVERY]: 'Entrega', // Entrega
  [TMSStepTypes.CANCELED]: 'Pedido cancelado',
  [TMSStepTypes.NOT_INCLUDED]: 'Transporte não contratado', // Transporte não contratado
  [TMSStepTypes.ARRIVAL_BRANCH]: 'Chegada filial',
};
